// extracted by mini-css-extract-plugin
export var postThumbnail = "style-module--postThumbnail--443f5";
export var postThumbnailFilters = "style-module--postThumbnail--filters--3a94a";
export var postThumbnailMostPopular = "style-module--postThumbnail--most-popular--4bf23";
export var postThumbnailPosts = "style-module--postThumbnail--posts--c032b";
export var postThumbnailRelated = "style-module--postThumbnail--related--3ce95";
export var postThumbnailTrending = "style-module--postThumbnail--trending--a8df2";
export var postThumbnail__author = "style-module--postThumbnail__author--a1b22";
export var postThumbnail__badge = "style-module--postThumbnail__badge--35978";
export var postThumbnail__category = "style-module--postThumbnail__category--a89aa";
export var postThumbnail__details = "style-module--postThumbnail__details--ff29d";
export var postThumbnail__image = "style-module--postThumbnail__image--925c3";
export var postThumbnail__largeBadge = "style-module--postThumbnail__large-badge--b0786";
export var postThumbnail__playIcons = "style-module--postThumbnail__play-icons--b57e1";
export var postThumbnail__playIconsTitle = "style-module--postThumbnail__play-icons-title--461b9";
export var postThumbnail__title = "style-module--postThumbnail__title--1e414";